import { render, staticRenderFns } from "./AssetsType.vue?vue&type=template&id=606ac217&scoped=true"
import script from "./AssetsType.vue?vue&type=script&lang=js"
export * from "./AssetsType.vue?vue&type=script&lang=js"
import style0 from "./AssetsType.vue?vue&type=style&index=0&id=606ac217&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606ac217",
  null
  
)

export default component.exports